export const SET_CONTEXT_MENU_VISIBILITY = "SET_CONTEXT_MENU_VISIBILITY";
export const SET_MULTIPLE_SELECTION = "SET_MULTIPLE_SELECTION";

interface ContextMenuCoordinates {
  top: number;
  left: number;
}

export interface ContextMenu {
  visibility: boolean;
  coordinates: ContextMenuCoordinates;
  selectedItemId: string;
  selectedItemsId: string[];
  clipboard: string;
  isMultipleSelection: boolean;
}

type ContextMenuAction = typeof SET_CONTEXT_MENU_VISIBILITY | typeof SET_MULTIPLE_SELECTION;

export interface ContextMenuPayload {
  type: ContextMenuAction;
  data: any;
}
